import React, {useRef} from 'react';
import OwlCarousel from "react-owl-carousel3";
import YouTube, { YouTubeProps } from 'react-youtube';
import {Link} from 'react-router-dom';
const VideoGallery = (props) => 
{
  const playerRef = useRef([]);
  const sources = [{id:1, title:"15 th Agust Celeberation", videoId:"2g811Eo7K8U"}, {id:2, title:"Event Celeberation", videoId:"Tl-j_CoFNZw"}, {id:3,  title:"Dance Show", videoId:"jOhqEtOOTwA"},];
  const onPlayerReady: YouTubeProps['onReady'] = (event) => {
    // access to player in all event handlers via event.target
    event.target.pauseVideo();
  }
  const opts: YouTubeProps['opts'] = {
    height: '200px',
    width: '100%',
    playerVars: {
      // https://developers.google.com/youtube/player_parameters
      autoplay: 0,
    },
  };
  const options = {
	 	loop:true,
		margin:30,
		nav:true,
		dots: false,
		navText: ['<i class="fa fa-chevron-left"></i>', '<i class="fa fa-chevron-right"></i>'],
		responsive:{
			0:{
				items:2
			},
			
			480:{
				items:3
			},			
			
			767:{
				items:4
			},
			1000:{
				items:5
			}
		}
    };	
  return(
	<div className="container">		
	  <OwlCarousel className="blog-carousel  owl-btn-vertical-center" {...options}>
		{sources.map((item, index) => (							
			
			<div className="item" key={item.id}>
				<div className="ow-event-post date-style-2">
					<div className="ow-event-media wt-img-effect zoom-slow">							
						<YouTube ref={playerRef[index]} videoId={item.videoId} opts={opts} onReady={onPlayerReady} />	
					</div>
					<div className="ow-event-info p-a30 bg-gray">
						<div className="ow-event-title">
							<h4 className="event-title"><Link to="/services-1" title="Video post">{item.title}</Link></h4>
						</div>
						
						
					</div>                                      
				</div>
			</div>																						  
		))}				
	</OwlCarousel> 
	</div>	
	  );
};
export default VideoGallery;